import { render, staticRenderFns } from "./CancelaDesdeXml.vue?vue&type=template&id=2b4713b8&"
import script from "./CancelaDesdeXml.vue?vue&type=script&lang=js&"
export * from "./CancelaDesdeXml.vue?vue&type=script&lang=js&"
import style0 from "./CancelaDesdeXml.vue?vue&type=style&index=0&id=2b4713b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QChip from 'quasar/src/components/chip/QChip.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QAvatar,QCardActions,QBtn,QSpace,QToolbar,QTooltip,QToolbarTitle,QSeparator,QInput,QIcon,QPopupProxy,QDate,QTable,QInnerLoading,QCheckbox,QTr,QTd,QChip});qInstall(component, 'directives', {ClosePopup});
